export default __webpack_public_path__ + "static/media/cp_geo_km.1d627348.svg";